export class VesselDeckModel {
  constructor(
    public id?: number,
    public vessel?: string,
    public currentStatus?: string,
    public deckNumber?: number,
    public deckName?: string,
    public deckType?: string,
    public linearMeters?: number,
    public squareMeters?: number,
    public length?: string,
    public width?: string,
    public fixedHeight?: string,
    public minimumHeight?: string,
    public maximumHeight?: string,
    public weightToleranceTons?: string,
    public accessibleFromStern?: boolean,
    public accessibleFromSide?: boolean,
    public createdAt?: string
  ) { }

  public fromJSON(json: any): VesselDeckModel {
    if (json) {
      this.id = json.id;
      this.vessel = json.vessel;
      this.currentStatus = json.currentStatus;
      this.deckNumber = json.deckNumber;
      this.deckName = json.deckName;
      this.deckType = json.deckType;
      this.linearMeters = json.linearMeters;
      this.squareMeters = json.squareMeters;
      this.length = json.length;
      this.width = json.width;
      this.fixedHeight = json.fixedHeight ?? null;
      this.minimumHeight = json.minimumHeight ?? null;
      this.maximumHeight = json.maximumHeight ?? null;
      this.weightToleranceTons = json.weightToleranceTons;
      this.accessibleFromStern = json.accessibleFromStern ?? false;
      this.accessibleFromSide = json.accessibleFromSide ?? false;
      this.createdAt = json.createdAt;
    }
    return this;
  }

  public fromJSONList(json: any): VesselDeckModel[] {
    if (json) {
      return json.map((element: any) => new VesselDeckModel().fromJSON(element));
    }
    return [];
  }

  public toJSON() {
    return {
      id: this.id,
      vessel: this.vessel,
      currentStatus: this.currentStatus,
      deckNumber: this.deckNumber,
      deckName: this.deckName,
      deckType: this.deckType,
      linearMeters: this.linearMeters,
      squareMeters: this.squareMeters,
      length: this.length,
      width: this.width,
      fixedHeight: this.fixedHeight,
      minimumHeight: this.minimumHeight,
      maximumHeight: this.maximumHeight,
      weightToleranceTons: this.weightToleranceTons,
      accessibleFromStern: this.accessibleFromStern ?? false,
      accessibleFromSide: this.accessibleFromSide ?? false,
      createdAt: this.createdAt,
    };
  }

  public getId() {
    return this.id?.toString() ?? '';
  }

  public getReference() {
    return this.deckName ?? '';
  }
}
